const companySettingsBookingTypes = {
    AVAILABLE: 'available',
    ENQUIRY: 'enquiry',
    RESERVATION: 'reservation',
    BOOKING: 'booking',
    VARIED: 'varied',
    NONE: 'none'
};

export {
    companySettingsBookingTypes
}
